import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { useGenerateArrayFromObj } from "../../../../components/input/hook/useGenerateOptions2";
import { MainContainerForm } from "../../../../styles/Main.styles";
import { useGetInvoiceConstant } from "../../api/invoice/constant/resolver";
import Input from "../../../../components/input/Input-v2";
import ProductWithPriceInvoice, {
  ProductWithPriceInvoiceData,
} from "../../../../components/product/ProductWithPrice-v2";
import Condition from "../../../../components/condition/Condition";
import PaymentMethodInput from "../__component/PaymentMethodInput";
import GrosirInput from "../__component/GrosirInput";
import RetailInput from "../__component/RetailInput";
import { NonEditableTableConfig } from "../../tableConfig/TableConfig";
import { M_ReturDetail } from "../../type/Invoice.type";

export interface Form_Create_Invoice {
  invoice_date: string;
  invoice_type: string;
  payment_method_id: string;
  invoice_status: string;
  product_list: any;
  customer_name: string;
  customer_address?: string;
  customer_phone_number?: string;
  sub_dealer_id?: string;
  payment_due_date?: string;
  description?: string;
}

export interface Form_Create_Retur {
  return_invoice_date: string;
  invoice_id: string;
  payment_method_id: string;
  product_list: any;
  description: string;
}

interface Form {
  dataRetur: M_ReturDetail;
}

export default function Form({ dataRetur }: Form) {
  const { control, setValue, watch } = useForm<Form_Create_Invoice>();
  const { body, header, lastRow } = NonEditableTableConfig(
    dataRetur.grand_total
  );
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data;
  const { data: dataInvoiceType } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.type,
  });
  const { data: dataInvoiceStatus } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.status,
  });
  const [productWithPriceData, setProductWithPriceData] = useState<
    ProductWithPriceInvoiceData[]
  >([]);
  const isFetching = fetchInvoiceConstant;

  useEffect(() => {
    setValue("customer_name", dataRetur.invoice.customer_name);
    setValue("payment_method_id", dataRetur.payment_method_id);
    setValue("payment_due_date", dataRetur.invoice.payment_due_date || "");
    setValue("customer_address", dataRetur.invoice.customer_address || "");
    setValue("description", dataRetur.description);
    setValue(
      "customer_phone_number",
      dataRetur.invoice.customer_phone_number || ""
    );
    setValue("sub_dealer_id", dataRetur.invoice.sub_dealer_id);
    setProductWithPriceData(
      dataRetur.return_invoice_detail.map((item) => {
        return {
          id: item.id,
          name: item.product.product_type_name,
          price: item.price,
          quantity: item.quantity,
          unitType: item.product.unit_type,
        };
      })
    );
  }, [dataRetur]);

  useEffect(() => {
    if (dataInvoiceConstant) {
      setValue("invoice_type", dataRetur.invoice.invoice_type);
      setValue("invoice_status", dataRetur.invoice.status);
    }
  }, [dataInvoiceConstant]);

  return (
    <form>
      <MainContainerForm mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input.Text
              showAsStatic
              label="Nomor Invoice Retur"
              value={dataRetur?.return_invoice_number}
            />
          </Grid>
          <Grid item xs={12}>
            <Input.Text
              showAsStatic
              label="Nomor Invoice"
              value={dataRetur.invoice.invoice_number}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="invoice_type"
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={isFetching}
                  label="Tipe Invoice"
                  options={dataInvoiceType || []}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="invoice_status"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={isFetching}
                  label="Status Invoice"
                  options={dataInvoiceStatus || []}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <PaymentMethodInput
            disable
            control={control}
            isPaymentForm={true}
            dataInvoiceConstant={dataInvoiceConstant}
            invoice_status={watch("invoice_status")}
          />
          <Condition.IF
            condition={
              watch("invoice_status") !== undefined &&
              watch("invoice_status") ===
                dataInvoiceConstant?.status["Belum Lunas"]
            }
          >
            <Grid item xs={12} md={12}>
              <Input.Controller
                control={control}
                name="payment_due_date"
                rules={{ required: "Kolom ini tidak boleh kosong" }}
                render={(field, fieldState) => (
                  <Input.Date
                    showAsStatic
                    isFetching={isFetching}
                    label="Tanggal Jatuh Tempo"
                    value={field.value}
                    onChange={(e) => field.onChange(e)}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
          </Condition.IF>
          <Condition.IF
            condition={
              watch("invoice_type") !== undefined &&
              watch("invoice_type") === dataInvoiceConstant?.type.Grosir
            }
          >
            <GrosirInput control={control} />
          </Condition.IF>
          <Condition.IF
            condition={
              watch("invoice_type") !== undefined &&
              watch("invoice_type") === dataInvoiceConstant?.type.Retail
            }
          >
            <RetailInput disable control={control} isFetching={isFetching} />
          </Condition.IF>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="description"
              render={(field) => (
                <Input.TextArea
                  showAsStatic
                  isFetching={isFetching}
                  label="Deskripsi Retur"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            />
          </Grid>
        </Grid>
      </MainContainerForm>
      <MainContainerForm>
        <ProductWithPriceInvoice
          body={body}
          header={header}
          lastRowRender={lastRow}
          invoiceType={watch("invoice_type")}
          dataProduct={productWithPriceData}
          onChange={(e) => setValue("product_list", e)}
        />
      </MainContainerForm>
    </form>
  );
}
